import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

/**
 * Hook that provides safe area insets with web compatibility.
 * On native platforms, returns actual safe area insets.
 * On web, returns default values (0) to avoid SafeAreaProvider dependency.
 */
export const useAvailableAreaInsets = () => {
    if (Platform.OS === 'web') {
        return { top: 0, bottom: 0, left: 0, right: 0 };
    }

    return useSafeAreaInsets();
};

export default useAvailableAreaInsets;
